import { render, staticRenderFns } from "./FornecedoresDialogCriar.vue?vue&type=template&id=1b9d3610&"
import script from "./FornecedoresDialogCriar.vue?vue&type=script&lang=ts&"
export * from "./FornecedoresDialogCriar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports